import * as R from 'ramda';
export const makeMenuItemFromString = R.converge(R.mergeRight, [R.assoc('key', R.__, {}), R.assoc('label', R.__, {})]);
export const makeMenuItemsFromString = R.map(makeMenuItemFromString);
